// MainMenuLoader.js
var MainMenuLoader = pc.createScript('mainMenuLoader');

MainMenuLoader.attributes.add("NextLevelAssets", { type: 'boolean', default: true});
MainMenuLoader.attributes.add("GameIconAssets", { type: 'boolean', default: true});

var downloadedImgArray = [];

MainMenuLoader.prototype.initialize = function () {

    splashAnimStatus = false;

    if (this.NextLevelAssets) { this.preloadNextLevelAssets(); }
    if (this.GameIconAssets) { this.preloadGameIconAssets(); }
};

MainMenuLoader.prototype.preloadNextLevelAssets = function () {

    let currentLevelData = PlayerManager.instance.userData.newPlayer ? "DonutItem" : PlayerManager.instance.levelData.levelItem;

    if ((PlayerManager.instance.levelData.levelName == "") || (currentLevelData != PlayerManager.instance.levelData.levelName)) {
        PreloadManager.instance.loadMiniGameAssets(currentLevelData,function(){});
    }
};

MainMenuLoader.prototype.preloadGameIconAssets = function() {

    var assets = this.app.assets.findByTag("mainPreload");
    var assetsLoaded = 0;
    var assestTotal = assets.length;
    
    var onAssetReady = function() {
        assetsLoaded += 1;
        if (assetsLoaded === assestTotal) {
           //console.log("mainPreloadlar Yüklendi");
        }
    };
    
    for(var i = 0; i < assets.length; i++) {
        if (assets[i].resource) {
            onAssetReady();
        } else {
            assets[i].ready(onAssetReady);
            this.app.assets.load(assets[i]);
        }
    }
};


